<template>
    <div class="modal fade history-filter-modal forgetwithdrawModal-cl" id="ChangeAndWithdrawPassword" data-bs-backdrop="static" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" data-bs-keyboard="false">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">
                    <div class="thm-heading">
                        <h3>Change Password</h3>
                    </div>
                    <button type="button" class="btn-close" aria-label="Close" v-if="$auth?.user?.last_login_at"></button>
                </div>
                <div class="modal-body">
                    <form class="withdraw_password_content change-password-sec">
                        <div class="cmn_withdraw_cl position-relative">
                            <input autocomplete="current-password" :type="oldPasswordFieldType" @input="oldPassword = $helper.sanitizeDetails('oldLoginPassword', oldPassword, 20); validate();"
                             v-model="oldPassword" class="form-control profit-input" placeholder="Current Password">
                            <i @click="togglePasswordVisibility('oldPasswordFieldType')"  
                                :class="['fas', 'togglePassword', oldPasswordFieldType == 'password' ? 'fa-eye-slash' : 'fa-eye']">
                            </i>
                            <template v-if="init.oldPassword && checkValidation?.oldPassword?.length > 0">
                                <span v-for="(err, index) in checkValidation?.oldPassword" :key="index" class="text-danger mt-2 error-messages-text">
                                &#x2022; {{ $t(err.lang, err.error) }}
                                </span>
                            </template>
                        </div>
                    
                        <div class="cmn_withdraw_cl position-relative">
                            <input autocomplete="new-password" :type="newPasswordFieldType" 
                            v-model="newPassword" @input="newPassword = $helper.sanitizeDetails('password', newPassword, 20); validate();"
                             class="form-control profit-input" placeholder="New Password">
                            <i @click="togglePasswordVisibility('newPasswordFieldType')"  
                                :class="['fas', 'togglePassword', newPasswordFieldType == 'password' ? 'fa-eye-slash' : 'fa-eye']">
                            </i>
                            <template v-if="init.newPassword && checkValidation?.password?.length > 0">
                                <span v-for="(err, index) in checkValidation?.password" :key="index" class="text-danger mt-2 error-messages-text">
                                &#x2022; {{ $t(err.lang, err.error) }}
                                </span>
                            </template>
                        </div>

                        <div class="cmn_withdraw_cl position-relative">
                            <input autocomplete="new-password" :type="confirmPasswordFieldType" 
                            v-model="confirmPassword" @input="confirmPassword = $helper.sanitizeDetails('password', confirmPassword, 20); validate();"
                             class="form-control profit-input" placeholder="Confirm New Password">
                            <i @click="togglePasswordVisibility('confirmPasswordFieldType')"  
                                :class="['fas', 'togglePassword', confirmPasswordFieldType == 'password' ? 'fa-eye-slash' : 'fa-eye']">
                            </i>
                            <template v-if="init.confirmPassword && checkValidation?.confirmPassword?.length > 0">
                                <span v-for="(err, index) in checkValidation?.confirmPassword" :key="index" class="text-danger mt-2 error-messages-text">
                                &#x2022; {{ $t(err.lang, err.error) }}
                                </span>
                            </template>
                        </div>

                        <template v-if="$siteSettings?.data?.business_type == 2">
                            <div class="cmn_withdraw_cl position-relative">
                                <input :type="withdrawPasswordFieldType"
                                v-model="withdrawPassword" @input="withdrawPassword = $helper.sanitizeDetails('withdrawPassword', withdrawPassword, 20); validate();"
                                 class="form-control profit-input" placeholder="New Withdraw Password">
                                <i @click="togglePasswordVisibility('withdrawPasswordFieldType')"  
                                    :class="['fas', 'togglePassword', withdrawPasswordFieldType == 'password' ? 'fa-eye-slash' : 'fa-eye']">
                                </i>
                                <template v-if="init.withdrawPassword && checkValidation?.withdrawPassword?.length > 0">
                                    <span v-for="(err, index) in checkValidation?.withdrawPassword" :key="index" class="text-danger mt-2 error-messages-text">
                                    &#x2022; {{ $t(err.lang, err.error) }}
                                    </span>
                                </template>
                            </div>

                            <div class="cmn_withdraw_cl position-relative">
                                <input :type="confirmWithdrawPasswordFieldType"
                                v-model="confirmWithdrawPassword" @input="confirmWithdrawPassword = $helper.sanitizeDetails('withdrawPassword', confirmWithdrawPassword, 20); validate();"
                                 class="form-control profit-input" placeholder="Confirm Withdraw Password">
                                <i @click="togglePasswordVisibility('confirmWithdrawPasswordFieldType')"  
                                    :class="['fas', 'togglePassword', confirmWithdrawPasswordFieldType == 'password' ? 'fa-eye-slash' : 'fa-eye']">
                                </i>
                                <template v-if="init.confirmWithdrawPassword && checkValidation?.confirmWithdrawPassword?.length > 0">
                                    <span v-for="(err, index) in checkValidation?.confirmWithdrawPassword" :key="index" class="text-danger mt-2 error-messages-text">
                                    &#x2022; {{ $t(err.lang, err.error) }}
                                    </span>
                                </template>
                            </div>
                        </template>
                        <button @click.prevent="changePassword()" type="button" class="btn_submit_cl thm-but">Submit</button>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import validate from '@/modules/authorization/services/authValidation';
export default {
	name: "ChangeAndWithdrawPasswordModal",
    props:{
        handleUserIdAndOffer: Function
    },
    data(){
        return{
            oldPassword: '',
            newPassword: '',
            confirmPassword: '',
            withdrawPassword: '',
            confirmWithdrawPassword: '',
            validationErrors : null,
            init:{
                oldPassword:false,
                newPassword:false,
                confirmPassword:false,
                withdrawPassword: false,
                confirmWithdrawPassword: false,
            },
            oldPasswordFieldType: 'password',
            newPasswordFieldType: 'password',
            confirmPasswordFieldType: 'password',
            withdrawPasswordFieldType: 'password',
            confirmWithdrawPasswordFieldType: 'password'
        }
    },
    computed: {
        checkValidation() {
            return this.validationErrors;
        }
    },
    methods:{
        setUserIdsToStore() {
            let userid = this.$auth?.user?.userid
            let oldUserIds = this.$store.getters?.logInData?.userIds || [];
            let loginWithMobileFromAuth  = this.$store.getters?.logInData?.logInWithMobile
            let data = {
                logInWithMobile: loginWithMobileFromAuth,
                userIds: oldUserIds
            }
            this.$store.dispatch('setLogInData', data);
        },
        changePassword(){
            this.toggleInit(true);
            const excludedKeys = ['withdrawPassword', 'confirmWithdrawPassword'];
            const isValid = this.$siteSettings?.data?.business_type == 2
                ? Object.keys(this.validate()).length === 0
                : Object.keys(this.validate()).filter(key => !excludedKeys.includes(key)).length === 0;

            if (!isValid) return;
            const changePasswordForm = new FormData();
            changePasswordForm.append("current_password", this.oldPassword);
            changePasswordForm.append("password", this.newPassword);
            changePasswordForm.append("confirm_password", this.confirmPassword);

            if (this.$siteSettings?.data?.business_type === 2) {
                changePasswordForm.append("withdrawPassword", this.withdrawPassword);
            }
            this.$apiCall('post', 'CHANGE_MY_PASSWORD', changePasswordForm).then(response => {
                if (response?.status == 200) {
                    if (response?.data?.error) {
                        this.$errorToast(response?.data?.error.toString());
                    } else {
                        let user = this.$auth.user;
                        user.is_fresh = 0;
                        user.is_password_secure = 1;
                        user.last_login_at = Math.floor(new Date().getTime() / 1000);
                        this.setUserIdsToStore();
                        this.$store.dispatch('setUser', user);
                        this.$successToast('Password changed successfully');
                        this.$helper.closeModal('ChangeAndWithdrawPassword');
                        this.handleUserIdAndOffer();
                    }
                }
            }).catch(error => {
                this.loading = false;
                if (error) {
                    console.log(error)
                    this.$errorToast(error[0]);
                }
            });
        },
        validate(){
            this.validationErrors = validate.areFieldsValid(
                'change-withdraw-password',
                this.oldPassword,
                this.newPassword,
                this.confirmPassword,
                this.withdrawPassword,
                this.confirmWithdrawPassword,
            );
            return this.validationErrors;
        },
        togglePasswordVisibility(fieldName) {
                this[fieldName] = this[fieldName] === 'password' ? 'text' : 'password';            
        },
        toggleInit(bool){
            this.init={
                oldPassword:bool,
                newPassword:bool,
                confirmPassword:bool,
                withdrawPassword: bool,
                confirmWithdrawPassword: bool
            }
        },
    }
}
</script>

<style>

.history-filter-modal.forgetwithdrawModal-cl {
	z-index: 99;
}

</style>